module.exports = __webpack_public_path__ + "assets/img/friendly-web.16e0cc25.png";